import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import { useFeatures } from '../../hooks/use-features'
import { colors, tabItem } from '../../components/ui/styles'
import { TAB_GROUPS } from './tab-groups'

export function SettingsPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const features = useFeatures()

  const segments = location.pathname.replace(/\/$/, '').split('/')
  const activeTab = segments[2] ?? 'providers'

  const visibleGroups = TAB_GROUPS.map((group) => ({
    ...group,
    tabs: group.tabs.filter((tab) => !tab.featureFlag || features[tab.featureFlag]),
  })).filter((group) => group.tabs.length > 0)

  return (
    <div>
      <div
        style={{
          background: colors.bgCard,
          borderBottom: `1px solid ${colors.tabBorder}`,
          padding: '0.5rem 0 0',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0',
        }}
      >
        {visibleGroups.map((group, idx) => (
          <div key={group.header} style={{ display: 'inline-flex', alignItems: 'center' }}>
            <span
              style={{
                fontSize: '0.6875rem',
                color: colors.textMuted,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                fontWeight: 700,
                padding: '0 0.4rem 0.5rem',
                whiteSpace: 'nowrap',
              }}
            >
              {group.header}
            </span>
            {group.tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => navigate(`/settings/${tab.key}`)}
                style={tabItem(activeTab === tab.key)}
              >
                {tab.label}
              </button>
            ))}
            {idx < visibleGroups.length - 1 && (
              <span
                style={{
                  display: 'inline-block',
                  width: '1px',
                  height: '20px',
                  background: colors.tabBorder,
                  margin: '0 0.4rem 0.5rem',
                }}
              />
            )}
          </div>
        ))}
      </div>
      <div style={{ paddingTop: '1rem' }}>
        <Outlet />
      </div>
    </div>
  )
}
